import PropTypes from 'prop-types';
import { Image } from '$components/basic/Image';
import Grid from '$components/layout/Grid';
import Advantages from '$components/Advantages';
import { PartOfRenault } from '$quantum/molecules/PartOfRenault';

const { Row, Col } = Grid;

function handleScrollToBtn() {
  const sectionToScroll = document.querySelector('.MostPopularLocationsSection');
  sectionToScroll.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest',
  });
}

export default function Bottom({ pageType, pageTypeFromPath }) {
  return (
    <Row className="bottom-wrapper">
      <Advantages pageType={pageType} pageTypeFromPath={pageTypeFromPath} />
      <Col span={12} className="part-of-renault">
        <PartOfRenault />
      </Col>

      <div
        aria-label="scroll to next section"
        className="goto-scroll"
        onClick={handleScrollToBtn}
        onKeyDown={handleScrollToBtn}
        role="button"
        tabIndex={0}
      >
        <Image
          provider="cloudinary"
          src="/icons/icon_arrow-bottom_bfyczz.svg"
          alt="down"
          layout="fixed"
          width="10"
          height="7"
        />
      </div>
    </Row>
  );
}

Bottom.propTypes = {
  pageType: PropTypes.array,
  pageTypeFromPath: PropTypes.string,
};

Bottom.defaultProps = {
  pageType: [],
  pageTypeFromPath: '',
};
